export default { 
  Auth: require('./auth').default,
  User: require('./user').default,
}
